export default "__VITE_ASSET__0VvjI8ep__"